import { render, staticRenderFns } from "./JobOfferAvailabilities.vue?vue&type=template&id=ddba10be&"
import script from "./JobOfferAvailabilities.vue?vue&type=script&lang=js&"
export * from "./JobOfferAvailabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports